import React from 'react';
import './AppLinks.css';

// Shared footer link row for every web app page. The current page is shown
// as plain text so each footer lists the full set without linking to itself.
const destinations = [
  { key: 'portfolio', label: 'Portfolio',     href: '/' },
  { key: 'converter', label: 'Converter',     href: '?converter' },
  { key: 'artyping',  label: 'ARTyping',      href: '?artyping' },
  { key: 'gallery',   label: 'Gallery',       href: '?gallery' },
  { key: 'qr',        label: 'QR Generator',  href: '?qr' },
  { key: 'phonewords', label: 'Phone Words',  href: '?phonewords' },
  { key: 'card',      label: 'Business Card', href: '?card' },
];

export default function AppLinks({ current }) {
  return destinations.map((d, i) => (
    <React.Fragment key={d.key}>
      {/* nbsp before the dot keeps it on the previous line; the normal space
          after it is the only place the row may wrap on narrow screens */}
      {i > 0 && <>&nbsp;·{' '}</>}
      {d.key === current
        ? <span className="app-links__item app-links__item--current" aria-current="page">{d.label}</span>
        : <a className="app-links__item" href={d.href}>{d.label}</a>}
    </React.Fragment>
  ));
}
